<template>
    <v-data-table
        :headers="headers"
        :items="itemsArr"
        :disable-pagination="true"
        :hide-default-footer="true"
        :disable-sort="true"
        class="data-table">

        <template #item.r_name="{ item }">
          <div style="width:200px">{{ item.r_name }}</div>
        </template>
        <template #item.upload_direction="{ item }">
          <div class="text-center">{{ $store.getters.t(item.upload_direction) }}</div>
        </template>
        <template #item.assetData.r_name="{ item }">
          <div style="width:180px">{{ item.assetData.r_name }}</div>
        </template>
        <template #item.assetData.upload_direction="{ item }">
          <div class="text-center">{{ $store.getters.t( item.assetData.upload_direction) }}</div>
        </template>

    </v-data-table>       
</template>
  
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
  data() {
    return {

      
    };
  },
  props: {
      headers: Array,
      type: String,
      datas: {
        type: Array,
        default: null
      },
  },
  methods: {
      
  
  },
  computed: {
      ...mapState('asset', ['assetInfo', 'selectedId']),
      itemsArr() {
        if(this.type === 'type01'){
          return [this.assetInfo].flatMap(e => e);
        } else {
          return this.datas;
        }
      }
  },
  mounted(){
  
  }
};
</script>
  
<style>
.data-table >>> .v-data-table__wrapper table tbody tr td {
    font-size: 13px;
}

.data-table >>> .v-data-footer__pagination {
  margin: 0; 
}
.data-table >>> .v-data-footer__icons-before {
  width: 20px;
}
  </style>
  